import {atom} from "recoil";

/**
 * 복지포인트 임시목록 페이지 body 
 * @type { RecoilState<{key : value}> }
 */


export const wpTempListSearch = atom({
    key: "wpTempListSearch",
    default: {
        mem_no : 0
        , page : 1
        , pageSize : 10
	}
});
